"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
require("./about.scss");
const About = (props) => {
    return (react_1.default.createElement(core_1.Box, { id: 'about', className: `v2-container-background ${props.className}` },
        react_1.default.createElement("h4", { className: 'v2-profile-block-heading' }, "About"),
        react_1.default.createElement("p", { dangerouslySetInnerHTML: { __html: props.bio.replace(/\n/g, "<br />") } })));
};
exports.default = About;
